import { SHOW_ADD_TO_HOME_SCREEN, HIDE_ADD_TO_HOME_SCREEN } from "../actions";

export function showAddToHomeScreen() {
  return {
    type: SHOW_ADD_TO_HOME_SCREEN
  };
}

export function hideAddToHomeScreen() {
  return {
    type: HIDE_ADD_TO_HOME_SCREEN
  };
}



// WEBPACK FOOTER //
// ./src/store/actionCreators/addToHomeScreen.js